// Dependencies
import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, PortType, RootState, UserType } from 'types';
import { FilterObjectType } from 'types/search';
import { checkDifferent, clone } from 'utils/formHandlers';
import { hasPermission } from 'utils/permission';

import AdminFilters from './AdminFilters';
import DateRangeFilters from './DateRangeFilters';
import MetOceanFilters from './MetOceanFilters';
import TagsAndCommentsFilters from './TagsAndCommentsFilters';
import TransitTagFilters from './TransitTagFilters';
import TransitTagRouteFilters from './TransitTagRouteFilters';
import VesselFilters from './VesselFilters';

interface FilterComponentProps {
    layout: Layout;
    filterObject: FilterObjectType;
    autoApply: boolean;
    defaultData: FilterObjectType;
    type: string;
    seFilterObject: (filterObject: FilterObjectType) => void;
    user: UserType;
    port: PortType;
}

interface FilterComponentState {
    layout: Layout;
    filterObject: FilterObjectType;
}

class Filter extends Component<FilterComponentProps, FilterComponentState> {
    constructor(props: FilterComponentProps) {
        super(props);
        this.state = {
            layout: clone(props.layout),
            filterObject: props.filterObject,
        };
    }

    static getDerivedStateFromProps(props: FilterComponentProps, state: FilterComponentState) {
        if (
            checkDifferent(props.layout, state.layout) ||
            (checkDifferent(props.filterObject, state.filterObject) && props.autoApply)
        ) {
            return { filterObject: props.filterObject, layout: clone(props.layout) };
        }
        return null;
    }

    setFilterObject = (filterObject): any => {
        delete filterObject.uuid;
        if (!this.props.autoApply) {
            this.setState({ filterObject });
        } else {
            this.props.seFilterObject(filterObject);
        }
    };

    checkSection = (section: string): boolean => {
        if (
            (this.state.layout.sections.chart.menus[`${this.props.type}Menu`].sections[section].state &&
                this.state.layout.sections.chart.state) ||
            (this.state.layout.sections.grid.menus[`${this.props.type}Menu`].sections[section].state &&
                this.state.layout.sections.grid.state) ||
            (this.state.layout.sections.profile.menus[`${this.props.type}Menu`].sections[section].state &&
                this.state.layout.sections.profile.state)
        ) {
            return true;
        }

        return false;
    };

    render() {
        return (
            <>
                {this.checkSection('tagsAndComments') && (
                    <TagsAndCommentsFilters
                        setFilterObject={this.setFilterObject}
                        filterObject={this.state.filterObject}
                    ></TagsAndCommentsFilters>
                )}

                {this.checkSection('dateRange') && (
                    <DateRangeFilters
                        type={this.props.type}
                        defaultData={this.props.defaultData}
                        withSortcut={this.props.type === 'search'}
                        setFilterObject={this.setFilterObject}
                        filterObject={this.state.filterObject}
                    ></DateRangeFilters>
                )}

                {this.checkSection('transit') && (
                    <TransitTagFilters
                        setFilterObject={this.setFilterObject}
                        filterObject={this.state.filterObject}
                    ></TransitTagFilters>
                )}

                {this.checkSection('transitRoute') && (
                    <TransitTagRouteFilters
                        setFilterObject={this.setFilterObject}
                        filterObject={this.state.filterObject}
                    ></TransitTagRouteFilters>
                )}

                {this.checkSection('vessel') && (
                    <VesselFilters
                        setFilterObject={this.setFilterObject}
                        filterObject={this.state.filterObject}
                    ></VesselFilters>
                )}

                {this.checkSection('metOcean') && (
                    <MetOceanFilters
                        setFilterObject={this.setFilterObject}
                        filterObject={this.state.filterObject}
                    ></MetOceanFilters>
                )}

                {hasPermission(this.props.user, this.props.port.id, ['searchForAdminTags']) &&
                    this.checkSection('admin') && (
                        <AdminFilters
                            setFilterObject={this.setFilterObject}
                            filterObject={this.state.filterObject}
                        ></AdminFilters>
                    )}

                {/* BACK 2.1 <LimitFilters
                    type={this.props.type}
                    setFilterObject={this.setFilterObject}
                    filterObject={this.state.filterObject}
                ></LimitFilters> */}
            </>
        );
    }
}

const filterStateToProps = (state: RootState) => ({
    user: state.user.user,
    port: state.port.port,
    layout: state.layout.layout,
});

const filterDispatchToProps = () => ({});

export default connect(filterStateToProps, filterDispatchToProps)(Filter);
